import { useState } from 'react';
import type { PurchaseHistory } from '../modules/DataTransformSchema';
import {
  getProductInitial,
  hasUsableProductImage,
} from '../utils/orderPresentation';

type ProductThumbProps = {
  order: PurchaseHistory;
  className?: string;
};

export function ProductThumb({ order, className = '' }: ProductThumbProps) {
  const [imageFailed, setImageFailed] = useState(false);
  const name = order.product_name || 'Unknown product';
  const showImage = hasUsableProductImage(order) && !imageFailed;

  return (
    <div
      className={`flex items-center justify-center overflow-hidden bg-rule-light font-display font-bold text-primary ${className}`}
    >
      {showImage ? (
        <img
          src={order.product_image}
          alt={name}
          loading="lazy"
          onError={() => setImageFailed(true)}
          className="h-full w-full object-contain"
        />
      ) : (
        <span aria-hidden="true">{getProductInitial(name)}</span>
      )}
    </div>
  );
}
